import React from "react";

const LoginHCCD = React.lazy(
  () => import("interface/screens/auth/login/index_hccd")
);
const LoginVNEID = React.lazy(
  () => import("interface/screens/auth/login/index_vneid")
);
const VneidLogin = React.lazy(
  () => import("interface/screens/auth/login/vneid_login")
);
const Register = React.lazy(() => import("interface/screens/auth/register"));
const About = React.lazy(() => import("interface/screens/auth/about"));

// const FormIO = React.lazy(() => import("interface/screens/formxacnhan/index"));
// const FormDone = React.lazy(
//   () => import("interface/screens/formhoanthanh/index")
// );

const authRoutes = [
  {
    path: "/oauth",
    sidebarName: "Oauth",
    component: <LoginHCCD />,
  },
  {
    path: "/vneid-login",
    sidebarName: "VneidLogin",
    component: <VneidLogin />,
  },
  {
    path: "/sso/vneid/signin",
    sidebarName: "Oauth",
    component: <LoginVNEID />,
  },
  {
    path: "/register",
    sidebarName: "Register",
    component: <Register />,
  },
  {
    path: "/about",
    sidebarName: "About",
    component: <About />,
  },
  // {
  //   path: "/f/:formname/:submissionid",
  //   component: <FormIO />,
  //   roles: [],
  // },
  // {
  //   path: "/xac-nhan-thanh-cong",
  //   component: <FormDone />,
  //   roles: [],
  // },
  { redirect: true, path: "*", to: "/oauth" },
];

export default authRoutes;

